<template>
    <div :class="['table-tr show task-type-'+taskIcon, {'task-is-in-future': !isToday}]">
        <div class="table-td task-title">
            <form action="">
                <template v-if="taskIsConsultation">
                    <span v-if="!task.deleted_at && isToday" class="btn-consultation-wrapper">
                        <input type="checkbox" :id="'task-'+task.id" name="task-checkbox" :checked="task.completed" :disabled="task.completed" :data-id="task.id">
                        <label class="btn-consultation btn-consultation-check tooltip tooltip-hover" :for="'task-'+task.id" :title="__('The consultation took place')" @click="markCompleted">
                            <span class="material-icons">done</span>

                            <div class="tooltip-content content-width left"><p>{{ __('The consultation took place') }}</p></div>
                        </label>
                        <button type="button" class="btn-consultation btn-consultation-cancel tooltip tooltip-hover" data-target="#task-consultation-cancel-modal" data-toggle="modal" :data-id="task.id" :title="__('Cancel consultation')" @click="setTaskId">
                            <span class="material-icons">close</span>

                            <div class="tooltip-content content-width center"><p>{{ __('Cancel consultation') }}</p></div>
                        </button>
                    </span>
                    <button v-else-if="!task.deleted_at && !isToday" type="button" class="btn-consultation btn-consultation-cancel tooltip tooltip-hover" data-target="#task-consultation-cancel-modal" data-toggle="modal" :data-id="task.id" :title="__('Cancel consultation')" @click="setTaskId">
                        <span class="material-icons">close</span>

                        <div class="tooltip-content content-width left"><p>{{ __('Cancel consultation') }}</p></div>
                    </button>
                    <button v-else type="button" class="btn-consultation btn-consultation-cancelled">
                        <span class="material-icons">close</span>
                    </button>
                </template>
                <template v-else-if="!taskIsConsultation && !isToday">
                    <div class="space"></div>
                </template>
                <template v-else>
                    <input type="checkbox" :id="'task-'+task.id" name="task-checkbox" :checked="task.completed" :disabled="task.completed" :data-id="task.id">
                    <label class="btn-consultation btn-consultation-check" :for="'task-'+task.id" @click="markCompleted">
                        <span class="material-icons">done</span>
                    </label>
                </template>
            </form>

            <figure class="task-icon">
                <svg-icon :icon="'tasks.'+taskIcon"></svg-icon>
            </figure>

            <strong v-html="__(task.title)"></strong>
        </div>

        <div class="table-td task-patient">
            <a v-if="task.patient" :href="'pacient/'+task.patient.id">
                <user-avatar :user-info="task.patient.user" size="sm"></user-avatar>

                <span>{{ task.patient.user | fullname }}</span>
            </a>
        </div>

        <div class="table-td task-date">
            <v-button v-if="taskIsNote && isToday" :href="'pacient/'+task.patient.id" :label="__('To the profile')" variant="secondary" size="sm"></v-button>
            <template v-else-if="taskIsCoachEvent"></template>
            <strong v-else>{{ task.date_formatted }}</strong>

            <consultation-call v-if="taskIsConsultation && isToday" :coach_name="coach.daktela_name" :cloudtalk_id="coach.cloudtalk_id" :phone_number="task.patient | phone"></consultation-call>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        task: {
            type: Object,
            required: true
        },
        coach: {
            type: Object
        },
        isToday: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {

        }
    },
    computed: {
        taskIsConsultation() {
            if(this.task.type.includes('Consultation')) {
                return true
            }

            return false
        },
        taskIsNote() {
            if(this.task.type.includes('Note')) {
                return true
            }

            return false
        },
        taskIsVacation() {
            if(this.task.type.includes('Vacation')) {
                return true
            }

            return false
        },
        taskIsCoachEvent() {
            if(this.task.type.includes('CoachEvent')) {
                return true
            }

            return false
        },
        taskIcon() {
            if(this.taskIsNote) {
                if(this.task.title === 'Last login 4 days ago' || this.task.title === 'Poslední přihlášení před 4 dny') {
                    return 'login'
                }

                if(this.task.title === '5 days left until the end of the prescription' || this.task.title === 'Zbývá 5 dnů do konce předpisu') {
                    return 'prescription'
                }
            }

            if(this.task.icon.includes('consultation_cancelled')) {
                return 'consultation_cancelled'
            }

            if(this.task.icon.includes('consultation_not_interested')) {
                return 'consultation_not_interested'
            }

            return this.task.icon
        }
    },
    watch: {

    },
    mounted() {
    },
    methods: {
        markCompleted() {
            this.task.completed = true

            axios.put('/muj-panel/tasks/mark-completed', { task_id: this.task.id })
                .catch(() => {
                    this.task.completed = false
                })
        },
        setTaskId() {
            const form = document.getElementById('task-consultation-cancel-form');
            form.setAttribute('action', `/tasks/${this.task.id}/consultation/cancel`);
        }
    }
}
</script>
